// extracted by mini-css-extract-plugin
export var measureBox = "_dj-0";